import React from "react";

//
// A button that takes them back to the start of the quiz
//
const RestartButton = ({ onRestart }) => {
  return (
    <div className="footer-lower">
    <button className="back-start" onClick={onRestart}>
      Back to Start
    </button>
    </div>
  );
};

export default RestartButton;
